import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'signin',
  label: 'Signin Section',
  description: 'Login form with phone/OTP flow and two-column layout.',
  supportedPages: ['signin'],
  variants: [{ id: 'v1', label: 'V1 (Two Column)' }],
  commonFields: [
    { key: 'redirectUrl', label: 'Redirect After Login', type: 'string', default: '/account' },
  ],
}
